export default __webpack_public_path__ + "static/media/NOSH-Logo.88527bb4.svg";